import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainDatatable from "../../../components/datatable/MainDatatable.jsx";
import DatatableHeading from "../../../components/datatable/DatatableHeading.jsx";
import { DeepSearchSpace, secondsToHMS } from "../../../utils/common-function/index.js";
import * as HistoryActions from '../../../redux/actions/historyAction';

const GasHistory = () => {
    const dispatch = useDispatch();
    const { serviceHistory } = useSelector(state => state?.historyReducer);

    console.log(serviceHistory);

    const [searchText, setSearchText] = useState('');
    const filteredData = DeepSearchSpace(serviceHistory, searchText);

    // Provider badge style helper
    const getProviderBadge = (provider) => {
        const styles = {
            A1TOPUP: { backgroundColor: '#4CAF50', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' },
            PAY2NEW: { backgroundColor: '#2196F3', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' },
            CYRUS: { backgroundColor: '#9C27B0', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' },
            DEFAULT: { backgroundColor: '#9E9E9E', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600' }
        };
        return styles[provider] || styles.DEFAULT;
    };

    //* Data-Table Column
    const columns = [
        { name: 'S.No.', selector: (row, index) => index + 1, width: '80px' },
        { name: 'Order Id', selector: row => row?.razorpayOrderId ? row?.razorpayOrderId : 'N/A', width: '180px' },
        { name: 'Consumer ID', selector: row => row?.number ? row?.number : 'N/A' },
        { name: 'Mobile', selector: row => row?.mobile ? row?.mobile : 'N/A' },
        { name: 'Total Price', selector: row => row?.amount && parseFloat(row?.amount).toFixed(2) },
        { name: 'Date', selector: row => row?.createdAt ? moment(row?.createdAt).format('DD MMM YYYY hh:mm A') : 'N/A', width: "180px" },
        { name: 'Bill Type', selector: row => row?.billType ? row?.billType : 'N/A'},
        { 
            name: 'Provider', 
            cell: row => (
                <span style={getProviderBadge(row?.provider)}>
                    {row?.provider ? row?.provider : 'N/A'}
                </span>
            ),
            width: '120px' 
        },
        { name: 'Status', selector: row => row?.status, width: '120px' },
        
    ];

    useEffect(function () {
        //! Dispatching API for Getting Gas History
        dispatch(HistoryActions.getServiceHistory({ search: 'GAS'}))
    }, [])

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <DatatableHeading
                    title="Gas History"
                    data={serviceHistory}
                    />

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "20px", alignItems: 'center', marginBottom: "20px", backgroundColor: "#fff" }}>
                    <input type='search' value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder='Search your data...' style={{ padding: '5px 10px', borderRadius: '5px', border: '1px solid #ccc', boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '250px', fontSize: '15px', outline: 'none', }} />
                </div>

                <MainDatatable columns={columns} data={filteredData} />
            </div>
        </>
    );
};

export default GasHistory;
